import { useQueries, useQuery } from 'react-query';

import { getAmenities, getAmenityCategories } from 'apis/AmenitiesAPI';
import { usePublicationContext } from 'components/Publication/PublicationContext';

import { getAmenitiesDataSource } from './utils';
import { useWidgetContext } from '../Widget/WidgetContext';

export const useGetAmenities = (community_ids: number[]) => {
  const { filters } = useWidgetContext();
  const { publication } = usePublicationContext();
  const amenitiesResponse = useQueries(
    community_ids.map((community_id) => ({
      queryKey: ['amenities', community_id],
      queryFn: () =>
        getAmenities(community_id, { checked: true, ...(publication?.hash ? { public_hash: publication.hash } : {}) }),
      enabled: Boolean(community_id),
      refetchOnWindowFocus: false,
    }))
  );

  const { data: categories, isLoading: isLoadingCategories } = useQuery({
    queryKey: ['amenities', 'categories'],
    queryFn: () => getAmenityCategories(),
    refetchOnWindowFocus: false,
  });

  if (isLoadingCategories) {
    return [];
  }

  return getAmenitiesDataSource(amenitiesResponse, categories, filters);
};
